import React, { useState, useContext, useEffect } from "react";
import Main from "../../layout/Main";
import AuthContext from "../../store/authContext";
import UserContext from "../../store/userContext";
import ReactLoading from "react-loading";
import mfaApi from "../../api/mfaApi";
import swal from "sweetalert";
import "react-loading-skeleton/dist/skeleton.css";

const UploadCourse = () => {
  const authCtx = useContext(AuthContext);
  const userCtx = useContext(UserContext);

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingdelete, setIsLoadingdelete] = useState(false);
  const [issearchLoading, setIssearchLoading] = useState(false);

  // Dropdown data arrays
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);
  const [subtopics, setSubtopics] = useState([]);
  const [chapters, setChapters] = useState([]);

  // Selected values
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedSubtopic, setSelectedSubtopic] = useState("");
  const [selectedChapter, setSelectedChapter] = useState("");

  // Upload modal states
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  // Add chapter modal
  const [showAddChapterModal, setShowAddChapterModal] = useState(false);
  const [chapterName, setChapterName] = useState("");
  const [addingChapter, setAddingChapter] = useState(false);

  // Fetch courses
  useEffect(() => {
    fetchCoursesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCoursesList = async () => {
    try {
      setIsLoading(true);
      const response = await mfaApi.get(`/administrator/courses`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authCtx.token}`,
        },
      });
      if (response.status === 200) {
        setCourses(response.data.courses || []);
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Failed to fetch courses",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubjects = async (courseId) => {
    try {
      setIsLoading(true);
      const response = await mfaApi.get(
        `/administrator/fetch-exam/${courseId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );
      if (response.status === 200) {
        setSubjects(response.data.allExamCourse || []);
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Failed to fetch subjects",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTopics = async (subjectId) => {
    try {
      setIsLoading(true);
      const response = await mfaApi.get(
        `/administrator/exam-category-exam/${subjectId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );
      if (response.status === 200) {
        setTopics(response.data.allExamCategoryExam || []);
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Failed to fetch topics",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSubtopics = async (topicId) => {
    try {
      setIsLoading(true);
      const response = await mfaApi.get(
        `/administrator/exam-category-subject/${topicId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );
      if (response.status === 200) {
        setSubtopics(response.data.AllExamSubject || []);
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Failed to fetch subtopics",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchChapters = async (subtopicId) => {
    try {
      setIsLoading(true);
      const response = await mfaApi.get(
        `/administrator/subject-book-category/${subtopicId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );
      if (response.status === 200) {
        setChapters(response.data.AllBook || []);
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Failed to fetch chapters",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  // Dropdown Handlers
  const handleCourseChange = (e) => {
    const id = e.target.value;
    setSelectedCourse(id);
    setSelectedSubject("");
    setSelectedTopic("");
    setSelectedSubtopic("");
    setSelectedChapter("");
    setSubjects([]);
    setTopics([]);
    setSubtopics([]);
    setChapters([]);
    if (id) fetchSubjects(id);
  };

  const handleSubjectChange = (e) => {
    const id = e.target.value;
    setSelectedSubject(id);
    setSelectedTopic("");
    setSelectedSubtopic("");
    setSelectedChapter("");
    setTopics([]);
    setSubtopics([]);
    setChapters([]);
    if (id) fetchTopics(id);
  };

  const handleTopicChange = (e) => {
    const id = e.target.value;
    setSelectedTopic(id);
    setSelectedSubtopic("");
    setSelectedChapter("");
    setSubtopics([]);
    setChapters([]);
    if (id) fetchSubtopics(id);
  };

  const handleSubtopicChange = (e) => {
    const id = e.target.value;
    setSelectedSubtopic(id);
    setSelectedChapter("");
    setChapters([]);
    if (id) fetchChapters(id);
  };

  // const handleChapterChange = (e) => {
  //   const id = e.target.value;
  //   setSelectedChapter(id);
  //   if (id) setShowUploadModal(true);
  // };
  const handleChapterChange = (e) => {
    const id = e.target.value;
    setSelectedChapter(id);

    if (!id) return;

    // Ask user for action: Upload or Delete
    swal({
  title: "Choose Action",
  text: "Do you want to Upload or Delete this chapter?",
  buttons: {
    cancel: "Cancel",
    upload: {
      text: "Upload",
      value: "upload",
      className: "bg-blue-600 text-white px-4 py-2 rounded",
    },
    delete: {
      text: "Delete",
      value: "delete",
      className: "bg-red-600 text-white px-4 py-2 rounded",
    },
  },
}).then((value) => {
      if (value === "upload") {
        setShowUploadModal(true); // Open upload modal
      } else if (value === "delete") {
        // Confirm before deleting
        swal({
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this chapter!",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            handleDeleteChapter(id);
          }
        });
      }
    });
  };

  const handleDeleteChapter = async (chapterId) => {
    try {
      setIsLoadingdelete(true);
      const response = await mfaApi.delete(
        `/administrator/delete-book/${chapterId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );

      if (response.status === 201) {
        swal("Success", "Chapter deleted successfully!", "success");
        fetchChapters(selectedSubtopic); // Refresh chapters list
        setSelectedChapter(""); // Reset selected chapter
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Failed to delete chapter",
        "error"
      );
    } finally {
      setIsLoadingdelete(false);
    }
  };


  // ========================= Add Chapter =========================
  const handleAddChapter = async () => {
    if (!chapterName.trim()) {
      swal("Please enter a chapter name", "", "warning");
      return;
    }

    try {
      setAddingChapter(true);
      const response = await mfaApi.post(
        `/administrator/add-book`,
        {
          name: chapterName,
          subjectId: selectedSubtopic,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authCtx.token}`,
          },
        }
      );

      if (response.status === 201) {
        swal("Success", "Chapter added successfully!", "success");
        setShowAddChapterModal(false);
        setChapterName("");
        fetchChapters(selectedSubtopic); // refresh chapters
      }
    } catch (error) {
      swal(
        "Error",
        error.response?.data?.message || "Failed to add chapter",
        "error"
      );
    } finally {
      setAddingChapter(false);
    }
  };

  // ========================= File Upload =========================
  const handleFileUpload = async () => {
    if (!selectedFile || !selectedChapter) {
      swal("Please select a PDF file", "", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("pdf", selectedFile);
    // formData.append("chapterId", selectedChapter);

    try {
      setUploading(true);
      const response = await mfaApi.put(
        `/administrator/uploadchapter/${selectedChapter}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authCtx.token}`,
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent);
          },
        }
      );

      if (response.status === 201) {
        swal("Success", "PDF uploaded successfully!", "success");
        setShowUploadModal(false);
        setSelectedFile(null);
        setPreviewUrl(null);
        fetchChapters(selectedSubtopic); // reload after upload
      }
    } catch (error) {
      swal("Error", error.response?.data?.message || "Upload failed", "error");
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  return (
    <Main>
      <section className="mx-auto w-full">
        <div className="bg-gray-100 rounded-md shadow-2xl shadow-green-600 py-1 mb-1">
          <p className="mx-auto flex justify-center uppercase text-black lg:text-2xl md:text-xl sm:text-lg font-sans text-center">
            Upload Course
          </p>
        </div>
      </section>

      {isLoading && (
        <div className="flex items-center justify-center my-2">
          <ReactLoading
            type="bubbles"
            color="#0143E2"
            height={"4%"}
            width={"4%"}
          />
          Loading...
        </div>
      )}

      <div className="grid grid-cols-4 gap-4 p-4 items-end">
        {/* Course */}
        <div>
          <label>Course</label>
          <select
            value={selectedCourse}
            onChange={handleCourseChange}
            className="border border-gray-300 rounded-md p-2 w-64"
          >
            <option value="">-- Select Course --</option>
            {courses.map((course) => (
              <option key={course.id} value={course.id}>
                {course.name}
              </option>
            ))}
          </select>
        </div>

        {/* Subject */}
        <div>
          <label>Subject</label>
          <select
            value={selectedSubject}
            onChange={handleSubjectChange}
            disabled={!selectedCourse}
            className="border border-gray-300 rounded-md p-2 w-64"
          >
            <option value="">-- Select Subject --</option>
            {subjects.map((subject) => (
              <option key={subject.id} value={subject.id}>
                {subject.name}
              </option>
            ))}
          </select>
        </div>

        {/* Topic */}
        <div>
          <label>Topic</label>
          <select
            value={selectedTopic}
            onChange={handleTopicChange}
            disabled={!selectedSubject}
            className="border border-gray-300 rounded-md p-2 w-64"
          >
            <option value="">-- Select Topic --</option>
            {topics.map((topic) => (
              <option key={topic.id} value={topic.id}>
                {topic.name}
              </option>
            ))}
          </select>
        </div>

        {/* Subtopic */}
        <div>
          <label>Subtopic</label>
          <select
            value={selectedSubtopic}
            onChange={handleSubtopicChange}
            disabled={!selectedTopic}
            className="border border-gray-300 rounded-md p-2 w-64"
          >
            <option value="">-- Select Subtopic --</option>
            {subtopics.map((subtopic) => (
              <option key={subtopic.id} value={subtopic.id}>
                {subtopic.name}
              </option>
            ))}
          </select>
        </div>

        {/* Chapter */}
        <div>
          <label>Chapter / Title</label>
          <div className="flex items-center gap-2">
            <select
              value={selectedChapter}
              onChange={handleChapterChange}
              disabled={!selectedSubtopic}
              className="border border-gray-300 rounded-md p-2 w-64"
            >
              <option value="">-- Select Chapter --</option>
              {chapters.map((chapter) => (
                <option key={chapter.id} value={chapter.id}>
                  {chapter.name}
                </option>
              ))}
            </select>

            {selectedSubtopic && (
              <button
                onClick={() => setShowAddChapterModal(true)}
                className="px-3 w-20 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                +
              </button>
            )}
          </div>
        </div>
      </div>

      {/* ================= Add Chapter Modal ================= */}
      {showAddChapterModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[400px]">
            <h3 className="text-lg font-semibold mb-3">Add New Chapter</h3>
            <input
              type="text"
              value={chapterName}
              onChange={(e) => setChapterName(e.target.value)}
              placeholder="Enter Chapter Name"
              className="border border-gray-300 rounded-md p-2 w-full"
            />
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => {
                  setShowAddChapterModal(false);
                  setChapterName("");
                }}
                className="px-3 py-2 bg-gray-300 rounded hover:bg-gray-400"
                disabled={addingChapter}
              >
                Cancel
              </button>
              <button
                onClick={handleAddChapter}
                className="px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                disabled={addingChapter}
              >
                {addingChapter ? "Adding..." : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= Upload Modal ================= */}
      {showUploadModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[768px]">
            <h3 className="text-lg font-semibold mb-3">Select PDF File</h3>

            <label
              htmlFor="fileInput"
              className="border-2 border-dashed border-gray-400 rounded-md p-6 flex flex-col items-center justify-center cursor-pointer hover:border-blue-500"
            >
              <svg
                className="w-8 h-8 text-gray-500 mb-2"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M16 12l-4-4m0 0l-4 4m4-4v12"
                />
              </svg>
              <p className="text-gray-600">
                {selectedFile ? selectedFile.name : "Upload a PDF file"}
              </p>
              <input
                id="fileInput"
                type="file"
                accept=".pdf"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file && file.type === "application/pdf") {
                    setSelectedFile(file);
                    const fileURL = URL.createObjectURL(file);
                    setPreviewUrl(fileURL);
                  } else {
                    swal("Only PDF files allowed", "", "error");
                    setSelectedFile(null);
                    setPreviewUrl(null);
                  }
                }}
                className="hidden"
              />
            </label>

            {selectedFile && previewUrl && (
              <div className="mt-4 border border-gray-300 rounded-md overflow-hidden">
                <object
                  data={previewUrl}
                  type="application/pdf"
                  width="100%"
                  height="250px"
                >
                  <p className="p-2 text-gray-500">
                    PDF preview not supported in this browser.
                  </p>
                </object>
              </div>
            )}

            {uploading && (
              <div className="mt-3 text-sm text-gray-700">
                Uploading... {uploadProgress}%
              </div>
            )}

            <div className="flex justify-end mt-4 gap-2">
              <button
                onClick={() => {
                  setShowUploadModal(false);
                  setPreviewUrl(null);
                  setSelectedFile(null);
                }}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                disabled={uploading}
              >
                Cancel
              </button>
              <button
                onClick={handleFileUpload}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                disabled={uploading || !selectedFile}
              >
                {uploading ? "Uploading..." : "Upload"}
              </button>
            </div>
          </div>
        </div>
      )}
    </Main>
  );
};

export default UploadCourse;
